import React from 'react';
import { Link } from 'react-router-dom';

const OrganizationalChart = ({ data }) => {
	// Agrupar nodos por company_name
	const groupedByCompany = data.reduce((acc, node) => {
		if (!acc[node.company_name]) {
			acc[node.company_name] = [];
		}
		acc[node.company_name].push(node);
		return acc;
	}, {});

	// Ordenar alfabéticamente por nombre de empresa
	const sortedCompanies = Object.entries(groupedByCompany).sort(([a], [b]) =>
		a.localeCompare(b)
	);

	// Renderizado recursivo de nodos hijos
	const renderTree = nodes => {
		return nodes.map(node => (
			<div className='first-list' key={node.id}>
				<div className='list-wrap'>
					<Link to='#' className='fw-medium text-primary'>
						{node.name.toUpperCase()}
					</Link>
				</div>
				{node.children && node.children.length > 0 && (
					<ul className='second-list list-unstyled'>
						{renderTree(node.children)}
					</ul>
				)}
			</div>
		));
	};

	// Render
	return (
		<div className='row'>
			{sortedCompanies.map(([companyName, nodes]) => (
				<div className='col' key={companyName}>
					<div className='verti-sitemap'>
						<ul className='mb-0 list-unstyled'>
							<li className='p-0 parent-title'>
								<Link to='#' className='fw-medium fs-14'>
									{companyName.toUpperCase()}
								</Link>
							</li>
							<li>{renderTree(nodes)}</li>
						</ul>
					</div>
				</div>
			))}
		</div>
	);
};

export default OrganizationalChart;
